import { Box, Typography } from "@mui/material"

import { priceToString } from "../../../utils/format-money"
import { CardBrand, OrderRow, paymentLabel } from "../Orders/orderTypes"
import { OrderDetailCard, OrderDetailField } from "./OrderDetailCard"

const mastercardIcon = require("../../../images/payment-icons/mastercard.svg").default
const visaIcon = require("../../../images/payment-icons/visa.svg").default
const pixIcon = require("../../../images/payment-icons/pix.svg").default

const cardBrandIcon: Record<CardBrand, JSX.Element> = {
  "mastercard": <img src={mastercardIcon} alt="Mastercard" width={40} height={40} />,
  "visa": <img src={visaIcon} alt="Visa" width={40} height={40} />,
}

type OrderPaymentCardProps = {
  order: OrderRow
}

export function OrderPaymentCard({ order }: OrderPaymentCardProps) {
  return (
    <OrderDetailCard title="Dados do Pagamento">
      <OrderDetailField label="Forma de Pagamento" value={paymentLabel[order.payment]} />

      {order.payment === "credit_card" && order.card && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {cardBrandIcon[order.card.brand]}
          <Box>
            <Typography variant="body2">{order.card.holder}</Typography>
            <Typography variant="body2" sx={{ letterSpacing: 1 }}>{order.card.maskedNumber}</Typography>
            <Typography variant="body2" color="text.secondary">{`expira em ${order.card.expiration}`}</Typography>
          </Box>
        </Box>
      )}

      {order.payment === "pix" && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <img src={pixIcon} alt="PIX" width={40} height={40} />
          <OrderDetailField label="Chave Pix" value={order.pixKey} />
        </Box>
      )}

      <OrderDetailField label="Quantidade de consultas" value={order.queryQuantity} />
      <OrderDetailField label="Valor" value={<Box component="span" sx={{ fontWeight: 500 }}>{`R$ ${priceToString(order.value)}`}</Box>} />
    </OrderDetailCard>
  )
}
